import React, { FC } from 'react';
import { observer } from 'mobx-react';
import ResponseEntity from '../../../../store/polls-store/response-entity';
import ProgressBar from '../../../shared/progress-bar/progress-bar';
import { ADDITIONAL_DELTA } from '../../../../constans/polls-constants';

interface IProps {
  response: ResponseEntity;
  totalCounts: number;
  shouldHideVotesCount?: boolean;
}

const PollResponseVotes: FC<IProps> = ({ response, totalCounts, shouldHideVotesCount }) => {
  const progressPercents = response.count ? (response.count / totalCounts) * ADDITIONAL_DELTA : 0;
  return (
    <div className='poll-response-vote'>
      <div className='poll-response-vote-choice'>{response.value}</div>
      {!shouldHideVotesCount && <div className='poll-response-vote-votes'>{response.count} Votes</div>}
      <ProgressBar percents={Math.floor(progressPercents)}/>
    </div>
  );
};

export default observer(PollResponseVotes);